import { SortableFields } from '../../data/useIntakes';
import { QueryParameterSchema } from './types';

export const sortableFields = [
  'createdAt',
  '-createdAt',
  'program.name',
  '-program.name',
  'intakeTerm.startsOn',
  '-intakeTerm.startsOn',
  'campus.name',
  '-campus.name',
];

export const sortFilterQueryFilter: QueryParameterSchema<'sort'> = {
  getDefaultValue: () => 'intakeTerm.startsOn,program.name,campus.name',
  getValue: ({ queryParameters }) => queryParameters.sort,

  fromUrlSearchParams: ({ urlSearchParams, defaultValue }) => ({
    sort: (urlSearchParams.get('sort') as SortableFields) ?? defaultValue,
  }),
  toUrlSearchParams: ({ value }) => ({ sort: value }),
  toSearchQuery: ({ value }) => {
    if (!value) return {};
    return { sort: value as SortableFields };
  },
  sanitize: ({ value, defaultValue }) => {
    if (!value) return { sort: defaultValue };
    const fields = value.split(',');
    const validFields = fields.filter((field) => sortableFields.includes(field as SortableFields));
    if (validFields.length === 0) return { sort: defaultValue };
    return { sort: validFields.join(',') };
  },
};
